<template>
  <base-legal-page
    title="Data Deletion Instructions"
    updated="January 2025"
  >
    <h2>Submit a Data Deletion Request</h2>
    <p>
      At Hacker Hang, we respect your right to control your personal data. All data deletion requests are handled via email.
    </p>
    <p>To request deletion of your personal data from our systems, please send an email to:</p>
    <div class="hh-legal__contact mb-6">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com?subject=Data%20Deletion%20Request">info@hackerhang.com</a></div>
      <div><strong>Subject:</strong> Data Deletion Request</div>
    </div>
    <p>Please include the following information in your request:</p>
    <ul>
      <li>Your full name</li>
      <li>Email address associated with your account</li>
    </ul>
    <p>
      We will process your request within 30 days and send you a confirmation once your data has been deleted.
    </p>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'DataDeletion',

    metaInfo: { title: 'Data Deletion' },
  }
</script>
